import { useSelector } from 'react-redux';
import axios from 'axios';
import { setRegToken, setEmployeydata } from '../Redux/Action/Authaction';
import { useNavigate } from "react-router-dom";
import {  useDispatch } from 'react-redux';

// Create an axios instance
const apiHandler = axios.create({
  baseURL: 'https://emsbackend.vigilantvisionsystem.com/ec2/api/v1', // Base URL for the API
});

// Custom hook to get the token and set Authorization header dynamically
export const useApiHandler = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const token = useSelector((state) => state.token);  // Get token from Redux store

  // Add request interceptor to include token in the header
  apiHandler.interceptors.request.use(
    (config) => {
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Add a response interceptor to handle errors
  apiHandler.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        dispatch(setRegToken(""));
        dispatch(setEmployeydata(""));
        navigate("/");      }
      return Promise.reject(error);
    }
  );

  return apiHandler;
};
